// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHorizontalSmallHeadingAndTextStyles } from "@guestsupply/App/SharedStyles/smallHeadingAndTextStyles";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SmallHeadingAndText, { SmallHeadingAndTextStyles } from "@insite/content-library/Components/SmallHeadingAndText";
import * as React from "react";

type Props = WidgetProps & HasProduct;

export interface MinQtyStyles {
    minOrderQty?: SmallHeadingAndTextStyles;
}

export const minQtyStyles: MinQtyStyles = {};

const styles = minQtyStyles;

const ProductDetailsMinQty: React.FC<Props> = ({ product }) => {
    if (!product.minimumOrderQty || product.minimumOrderQty < 2) {
        return null;
    }
    return (
        <SmallHeadingAndText
            extendedStyles={styles.minOrderQty}
            text={product.minimumOrderQty}
            heading={translate("Minimum quantity is")}
        />
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsMinQty),
    definition: {
        displayName: "Min. Order Qty",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
